import React from "react";
import Navbar from "../Components/NavBar/NavBar";
import TabsAdmin from '../Components/Admin/TabsAdmin'

function Admin() {
  return (
    <div>
      <Navbar />
    <TabsAdmin/>
    </div>
  );
}

export default Admin;
